import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b98c22ac&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b98c22ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98c22ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b98c22ac')) {
      api.createRecord('b98c22ac', component.options)
    } else {
      api.reload('b98c22ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b98c22ac&scoped=true&", function () {
      api.rerender('b98c22ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistic/order-count/index.vue"
export default component.exports